var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoom3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5758 2.90909C14.1114 2.90909 14.5455 3.34324 14.5455 3.87879V8.24242H20.1213C20.6568 8.24242 21.091 8.67657 21.091 9.21212V14.7879C21.091 15.3234 20.6568 15.7576 20.1213 15.7576H14.5455V20.1212C14.5455 20.6568 14.1114 21.0909 13.5758 21.0909H3.87888C3.34333 21.0909 2.90918 20.6568 2.90918 20.1212V3.87879C2.90918 3.34324 3.34333 2.90909 3.87888 2.90909H13.5758ZM4.84857 19.1515H12.6061V14.7879C12.6061 14.2523 13.0403 13.8182 13.5758 13.8182H19.1516V10.1818H13.5758C13.0403 10.1818 12.6061 9.74767 12.6061 9.21212V4.84848H4.84857V19.1515Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoom3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room_3.95b211d5385c6e0a96ccc7ad298baefb.svg";